import { useNavigate } from 'react-router';
import { Button } from '@chakra-ui/react';
import Cookies from 'js-cookie';
import { LuLogOut } from 'react-icons/lu';


const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove('accessToken');
    navigate('/', { replace: true });
  };

  return (
    <Button
      onClick={handleLogout}
      variant="ghost"
    >
      <LuLogOut /> Sair
    </Button>
  );
};

export default Logout;
